module.exports = __webpack_public_path__ + "img/wifi.a76b693e.svg";